// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0RFF9","title":"styles_title__FGubP"};